import {useState} from "react";
import moment, {Moment} from "moment";

export function useDatePicker() {
  const [date, setDate] = useState<Moment>(moment())
  return {
    date, setDate,
  }
}
